import { render, staticRenderFns } from "./IntField.vue?vue&type=template&id=b05b7cee&lang=pug&"
import script from "./IntField.vue?vue&type=script&lang=js&"
export * from "./IntField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b05b7cee')) {
      api.createRecord('b05b7cee', component.options)
    } else {
      api.reload('b05b7cee', component.options)
    }
    module.hot.accept("./IntField.vue?vue&type=template&id=b05b7cee&lang=pug&", function () {
      api.rerender('b05b7cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/IntField.vue"
export default component.exports